// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"214cc565","453":"f22b0ff3","732":"e1272314","977":"75d97c52"}[chunkId] + ".chunk.js";
};